export const INVENTORY_SET_ACL_OBJECTS = [
    'InventorySetEdit',
    'InventorySetList',
];
